import type { TranslationResource } from './en';

export const de: TranslationResource = {
  title: 'AutoCut - Installationsprogramm',
  downloading: 'AutoCut wird heruntergeladen',
  downloadedTitle: 'AutoCut wurde erfolgreich heruntergeladen !',
  closingCountdown: 'Schließt in {{count}} Sekunden',
  alreadyInstalledTitle: 'AutoCut ist bereits installiert',
  alreadyInstalledHelp:
    'AutoCut läuft jetzt als Desktop-App. Sie können diese Erweiterung über die Creative Cloud App deinstallieren.',
};
